import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash/get';

import { CDNImgUrl } from '../../utils/CDNImgUrl';


const DocumentParagraph = ({ element }) => {
    const publicURL = _get(element, 'relationships.field_document.relationships.field_media_document.uri.value', '');
    const name = _get(element, 'relationships.field_document.name', '');
    const fileName = _get(element, 'relationships.field_document.relationships.field_media_document.name', '');
    const description = _get(element, 'relationships.field_document.field_media_document.description', '');
    const title = _get(element, 'field_title', '');
    const [file, setFile] = useState(CDNImgUrl(publicURL));
    const type = _get(element, "internal.type", "");
    const paragraphClasses = `${type} ${type}_${element?.id}`;

    useEffect(() => {
        setFile(CDNImgUrl(publicURL));
    }, [publicURL]);

    return <a className={`navigation-link document-paragraph ${paragraphClasses}`}
        href={file}
        alt={description || name || fileName}
        download
    >
        <span className="navigation-link-text">{title || description || name || fileName}</span>
    </a>;
};

export default DocumentParagraph;

DocumentParagraph.propTypes = {
    element: PropTypes.objectOf(PropTypes.any),
};
